import React from 'react';
import Head from 'next/head';

export function InformationSection({ id, title, children }) {
    return (
        <section className="InformationPage__section" id={id}>
            <h2>{title}</h2>
            {children}
        </section>
    );
}

export default function InformationPage({ title, description, path, intro, children }) {
    const canonicalUrl = `https://www.tabextend.com${path}`;
    const fullTitle = `${title} | tabExtend`;

    return (
        <>
            <Head>
                <title>{fullTitle}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={canonicalUrl} />
                <meta property="og:title" content={fullTitle} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta name="robots" content="index,follow" />
            </Head>
            <main className="InformationPage">
                <div className="container InformationPage__container">
                    <h1>{title}</h1>
                    <p className="InformationPage__intro">{intro}</p>
                    {children}
                </div>
            </main>
        </>
    );
}
